import { Party } from './Party';
export function Viewer(props) {
    const { name, email, message } = props;
    return <Party name={name} email={email} message={message}/>;
}
